module.exports = __webpack_public_path__ + "../panel-assets/img/promotion-slot-img-EN.200eb71d.png";